import {
	Button,
	Stack,
	TextField,
	TextFieldProps,
	Typography,
} from '@mui/material';
import { FeedbackTagBox } from 'components';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MotionWrapper } from 'utils';

const FeedbackHistory = () => {
	const { t } = useTranslation();
	const titleField = useRef<TextFieldProps>(null);
	const [title, setTitle] = useState<string>('');

	const handleSearch = () => {
		setTitle(
			titleField.current && typeof titleField.current.value === 'string'
				? titleField.current.value
				: ''
		);
	};

	return (
		<MotionWrapper spacing={0}>
			<Stack spacing={1} p={2} pt={1} direction="row">
				<TextField
					className="inputRounded"
					fullWidth
					type="text"
					inputRef={titleField}
					label={t('feedback.title')}
					size="small"
				/>
				<Button disableRipple onClick={handleSearch}>
					{t('default.search')}
				</Button>
			</Stack>
			<Typography pl={2} pb={1}>
				{t('feedback.history')}
			</Typography>
			<FeedbackTagBox title={title} />
		</MotionWrapper>
	);
};

export default FeedbackHistory;
